// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button[data-v-72364c30] {\n  --button-hollow-background: var(--magic-success, #2dffdb);\n  --magic-text-primary: var(--magic-tertiary, #311261);\n  --button-hollow-primary-hover-color: #68d7bc;\n  --button-hollow-border-hover-color: #68d7bc;\n}", ""]);
// Exports
module.exports = exports;
